import PropTypes from "prop-types";
import vipStar from "../../../assets/images/star-icon.png";
import "./VipStar.scss";

const VipStar = ({ className = "" }) => (
  <img
    src={vipStar}
    alt=""
    className={`vip-inline-star${className ? ` ${className}` : ""}`}
  />
);

VipStar.propTypes = {
  className: PropTypes.string,
};

export default VipStar;
